"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Flag_exports = {};
__export(Flag_exports, {
  default: () => Flag_default
});
module.exports = __toCommonJS(Flag_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M4.26953 4.23438L10.1875 2.76953C10.3698 2.73047 10.5391 2.76302 10.6953 2.86719C10.8646 2.95833 10.9753 3.09505 11.0273 3.27734L11.2617 4.19531L15.6172 3.12109C15.7995 3.08203 15.9753 3.11458 16.1445 3.21875C16.3138 3.3099 16.4245 3.45312 16.4766 3.64844L17.9609 9.74219C18 9.9375 17.9674 10.1198 17.8633 10.2891C17.7721 10.4453 17.6354 10.5495 17.4531 10.6016L12.8242 11.7539C12.6419 11.806 12.4661 11.7865 12.2969 11.6953C12.1276 11.5911 12.0169 11.4479 11.9648 11.2656L11.7305 10.4258L6.06641 11.8711L7.33594 17.1836C7.36198 17.3138 7.33594 17.4375 7.25781 17.5547C7.19271 17.6719 7.08854 17.75 6.94531 17.7891C6.8151 17.8151 6.69141 17.7956 6.57422 17.7305C6.45703 17.6523 6.38542 17.5417 6.35938 17.3984L3.17578 3.98047C3.14974 3.85026 3.16927 3.72656 3.23438 3.60938C3.3125 3.49219 3.41667 3.41406 3.54688 3.375C3.6901 3.34896 3.82031 3.375 3.9375 3.45312C4.05469 3.51823 4.1263 3.61589 4.15234 3.74609L4.26953 4.23438Z",
      fill: "currentColor"
    }
  )
);
const SvgFlag = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Flag_default = SvgFlag;
